import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconZoomOut$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconZoomOut extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '1489a30abc866977c0382454f426128deca979cf', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '01d787e78a3d570b8a159fef7a82eae327425e2d', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'd45d4698d20cd7fdb67f4c34d5717d9868811125', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3 9a6 6 0 1 1 12 0A6 6 0 0 1 3 9m10.5 0A4.5 4.5 0 0 0 9 4.5 4.51 4.51 0 0 0 4.5 9a4.5 4.5 0 1 0 9 0M6 8.75a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5zm8.628 6.213a.5.5 0 0 0 0 .707l3.5 3.5a.5.5 0 0 0 .707 0l.353-.354a.5.5 0 0 0 0-.707l-3.5-3.5a.5.5 0 0 0-.707 0z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-zoom-out", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-zoom-out"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-zoom-out":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconZoomOut$1);
            }
            break;
    } });
}

const CosmosIconZoomOut = CosmosIconZoomOut$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconZoomOut, defineCustomElement };
